import { useEffect, useCallback } from "react";

/**
 * Aplica la protección contra capturas/click derecho.
 * Recibe `disabled` ya calculado por el llamador (GlobalProtection),
 * que es quien consulta `useSettings` y `useSuperAdmin`.
 * No llama a otros hooks de contexto para evitar dobles suscripciones
 * y problemas de orden de hooks tras HMR.
 */
export function useScreenCaptureProtection(disabled = false) {
  const handleContextMenu = useCallback((e: MouseEvent) => {
    // Determine the target element
    const target = e.target as HTMLElement;
    
    // Always allow context menu on input fields, textareas, and contenteditable elements
    const isInput = target.tagName === 'INPUT' || 
                   target.tagName === 'TEXTAREA' || 
                   target.isContentEditable;
    
    if (isInput) return;

    console.log("[RightClickProtection]", {
      attempted: "contextmenu",
      isActuallyBlocking: !disabled,
      disabledParam: disabled,
      timestamp: new Date().toISOString(),
    });
    
    if (!disabled) {
      e.preventDefault();
    }
  }, [disabled]);

  useEffect(() => {
    if (disabled) {
      document.body.classList.add("allow-select");
      return;
    }

    document.body.classList.remove("allow-select");

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "PrintScreen") {
        e.preventDefault();
        navigator.clipboard.writeText("").catch(() => {});
      }
      if (e.ctrlKey && e.shiftKey && ["I", "i", "J", "j"].includes(e.key)) {
        e.preventDefault();
      }
      if (e.ctrlKey && (e.key === "u" || e.key === "U")) {
        e.preventDefault();
      }
      if (e.ctrlKey && (e.key === "s" || e.key === "S")) {
        e.preventDefault();
      }
      if (e.metaKey && e.shiftKey && ["3", "4", "5"].includes(e.key)) {
        e.preventDefault();
      }
      if (e.key === "F12") {
        e.preventDefault();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("contextmenu", handleContextMenu);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, [disabled, handleContextMenu]);
}
